module.exports = __webpack_public_path__ + "static/media/logo.06700d00.svg";